document.addEventListener("DOMContentLoaded", function () {
  const artist = "Al Safir",
    appId = "cf7833aba4e1ea76b5f3928479fa516c",
    container = document.getElementById("bandsintown-events");
  container.innerHTML = "";
  fetch(`https://rest.bandsintown.com/artists/${encodeURIComponent(artist)}/events?app_id=${appId}`)
    .then((response) => response.json())
    .then((events) => {
      if (!events || events.length === 0) {
        container.innerHTML = "<p>No hay conciertos próximos.</p>";
        return;
      }
      events.forEach((event) => {
        const card = document.createElement("div");
        card.className = "bandsintown-event-card";
        const eventDate = new Date(event.datetime),
          formattedDate = eventDate.toLocaleDateString(),
          formattedTime = eventDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

        // Enlace de venta directo (offers[0].url) en vez de la ficha del evento (event.url).
        // Si el evento aún no tiene entradas a la venta (offers vacío), usamos event.url como respaldo.
        const ticketUrl =
          event.offers && event.offers.length > 0 && event.offers[0].url
            ? event.offers[0].url
            : event.url;

        card.innerHTML = `
          <h3>${event.venue.name}</h3>
          <p>${event.venue.city}, ${event.venue.country}</p>
          <p class="event-datetime">${formattedDate} - ${formattedTime}</p>
          <a class="btn" href="${ticketUrl}" target="_blank">Comprar Entradas</a>
        `;
        container.appendChild(card);
      });
    })
    .catch((error) => {
      console.error("Error cargando eventos:", error);
      container.innerHTML = "<p>Error al cargar los conciertos.</p>";
    });
});